// extracted by mini-css-extract-plugin
module.exports = {"error_icon":"antd-pro-pages-result-fail-index-error_icon","title":"antd-pro-pages-result-fail-index-title"};